export default "/_next/static/images/no-picture@2x-04890b324e09d488167d710dea1bb03e.png";